import serverCall from "../../serverCall";

const getAllImage = async (type) => {
  const response = await serverCall.get(`/pradict-race-image/admin?type=${type}`);
  return response;
};

const AddImage = async (name, data, link, index, countryCodes, type) => {
  const response = await serverCall.post(
    `/pradict-race-image/upload-image/admin?name=${name}&link=${link}&index=${index}&countryCodes=${countryCodes}&type=${type}`,
    data
  );
  return response;
};
const UpdateImage = async (id, name, data, link, index, type, countryCodes, imageIds) => {
  
  const response = await serverCall.put(
    `/pradict-race-image/update-image/admin?id=${id}&name=${name}&link=${link}&index=${index}&type=${type}&countryCodes=${countryCodes}&imageIds=${imageIds}`,
    data
  );
  return response;
};
const ImageDelete = async (id) => {
  const response = await serverCall.delete(`/pradict-race-image/${id}`);
  return response;
};
const GetImage = async (id) => {
  const response = await serverCall.get(
    `/pradict-race-image/find-one/admin?id=${id}`
  );
  return response;
};

const DeleteLanguageRace = async (id, imageId) => {
  const response = await serverCall.delete(`/pradict-race-image/delete-image/admin?id=${id}&imageId=${imageId}`);
  return response;
};

const ImageService = {
  getAllImage,
  AddImage,
  UpdateImage,
  ImageDelete,
  GetImage,
  DeleteLanguageRace
};

export default ImageService;
